import styled from 'styled-components'

import type { VALID_IMAGE_LAYOUTS } from './constants'
import { LAYOUT_RESPONSIVE, LAYOUT_CONTAIN, LAYOUT_COVER } from './constants'

interface IImageBaseProps {
  $layout: (typeof VALID_IMAGE_LAYOUTS)[number]
  $aspectRatio?: string
}

export const ImageBase = styled.div<IImageBaseProps>`
  img {
    object-fit: cover;
    object-position: center;
    pointer-events: none;
    user-select: none;
    vertical-align: bottom;
    ${props => props.$layout === LAYOUT_RESPONSIVE && `width: 100%;`}
    ${props => props.$layout === LAYOUT_CONTAIN && `object-fit: contain;`}
    ${props => props.$layout === LAYOUT_COVER && `object-fit: cover;`}
    ${props => props.$aspectRatio && `aspect-ratio: ${props.$aspectRatio};`}
  }
`
